import BaseLayout from '@layouts/BaseLayout'
import classNames from '@utils/class-names.util'
import { FC, Fragment, memo } from 'react'
import ScrollLayout from '@layouts/ScrollLayout'
import { NavLink } from '..'

import { IconType } from 'react-icons/lib'
import { FaChevronDown } from 'react-icons/fa'
import { useSidebar } from './useSidebar.hook'
import './index.scss'
import AccordionLayout from '@layouts/AccordionLayout'

export interface SidebarMenu {
    label: string
    to: string
    icon: IconType
    subLinks?: SidebarMenu[]
    isOpen?: boolean
    onClick?: () => void
}

type SidebarMenuProps = {
    items: SidebarMenu
}

type Sidebar = {
    className?: string
}

const MenuItem: FC<SidebarMenuProps> = ({ items }) => {
    return (
        <NavLink
            to={items.to}
            onClick={items.onClick}
            className="sidebar__option"
            activeClassName="sidebar__option--active"
        >
            <i className="sidebar__option__icon">
                <items.icon size="32" />
            </i>
            <span className="sidebar__option__text">{items.label}</span>

            {items?.subLinks && (
                <i
                    className={classNames(
                        'sidebar__option__sub',
                        items.isOpen ? 'sidebar__option__sub--open' : ''
                    )}
                >
                    <FaChevronDown />
                </i>
            )}
        </NavLink>
    )
}

const Sidebar: FC<Sidebar> = ({ className }) => {
    const { sidebarProps } = useSidebar()

    return (
        <BaseLayout className={classNames('sidebar', className)}>
            <aside className="sidebar__content">
                <div className="sidebar__header">
                    {/* <img className="sidebar__logo" src={Logo} /> */}
                    <h3 className="sidebar__logo">Cryplön</h3>
                </div>

                <ScrollLayout className="sidebar__wrapper">
                    <div className="sidebar__options">
                        {sidebarProps?.map((link, index) => (
                            <Fragment key={`side_${index}`}>
                                {link.subLinks ? (
                                    <AccordionLayout
                                        className="sidebar__option__accordion"
                                        isAccordion={link.isOpen}
                                        accordion={
                                            <div className="sidebar__option__accordion__content">
                                                {link.subLinks.map(
                                                    (subLink, subIndex) => (
                                                        <Fragment
                                                            key={`side_${index}_${subIndex}`}
                                                        >
                                                            <MenuItem
                                                                items={subLink}
                                                            />
                                                        </Fragment>
                                                    )
                                                )}
                                            </div>
                                        }
                                    >
                                        <MenuItem items={link} />
                                    </AccordionLayout>
                                ) : (
                                    <MenuItem items={link} />
                                )}
                            </Fragment>
                        ))}
                    </div>
                </ScrollLayout>

                <div className="sidebar__others">
                    <hr className="sidebar__separator" />
                </div>
            </aside>
        </BaseLayout>
    )
}

export default memo(Sidebar)
